const updatePlacesStr = {
  toastr: 'Lugar atualizada',
  toastr1: 'foi atualizada com sucesso',
  toastrError: 'Lugar já cadastrada',
  toastrError1: 'Insira outro nome'
};

export default updatePlacesStr;
